import styled from 'styled-components';
import { Badge, Box, Text } from '@usealloy/component-library';
import type { NodeState } from 'flow/service/graph';
import { NODE_TEXT_MAX_WIDTH, NODE_HEIGHT_XL, NODE_WIDTH } from 'flow/service/graph';

export const snippetFocusedStyle = {
  border: '1px solid var(--cl-purple-500)',
  boxShadow: `
    2px 2px 0px 0px var(--cl-purple-500),
    0px 0px 0px 4px color-mix(in srgb, var(--cl-purple-300) 70%, transparent),
    4px 4px 0px 4px color-mix(in srgb, var(--cl-purple-200) 60%, transparent)
  `,
};

export const StyledSnippetIconContainer = styled(Box)`
  align-items: center;
  background: var(--cl-purple-400);
  border-radius: var(--cl-radius-3);
  justify-content: center;
  padding: var(--cl-space-1);
  margin-right: var(--cl-space-1);
  width: fit-content;
`;

export const StyledLabelText = styled(Text)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: calc(${NODE_TEXT_MAX_WIDTH}px - 24px);
`;

export const StyledVersionBadge = styled(Badge)`
  border: 1px solid var(--cl-gray-600);
  color: var(--cl-gray-800);
  font-size: var(--cl-font-size-1);
  background-color: var(--cl-gray-000);
`;

export const StyledLabelContainer = styled(Box)`
  flex-direction: column;
  align-items: flex-start;
  max-width: 116px;
`;

export const StyledDropNode = styled.div<{ nodeState: NodeState }>`
  background-color: var(--cl-gray-100);
  border: 1px solid var(--cl-gray-300);
  border-radius: var(--cl-radius-3);
  box-shadow: 0px 0px var(--cl-space-3) var(--cl-gray-500);
  height: ${NODE_HEIGHT_XL}px;
  width: ${NODE_WIDTH}px;

  ${({ nodeState }) => {
    if (nodeState === 'hovered') return 'background-color: var(--cl-gray-200);';
    if (nodeState === 'faded') return 'background-color: var(--cl-gray-200);';
    if (nodeState === 'deemphasized') return 'background-color: var(--cl-gray-200);';
    return 'background-color: var(--cl-gray-100);';
  }}

  z-index: -1;
  position: absolute;
  left: var(--cl-space-1);
  top: 0.3rem;
`;
